<div class="flex h-full w-full items-center justify-center bg-proffeo-surface-page">
  <div class="flex flex-col items-center justify-center gap-5">
    <div class="flex items-center gap-4">
      <div class="flex items-center gap-2">
        <img
          src="img/logo/logo.png"
          alt="logo"
          class="w-11"
        />
        <p class="proffeo-ui-text-display">Proffeo</p>
      </div>
      <proffeo-lang-toggle class="p-2"></proffeo-lang-toggle>
    </div>
    <div class="min-w-90 flex items-center justify-center border-default bg-proffeo-surface p-8">
      <div class="flex w-full flex-col gap-2">
        <div class="flex w-full items-center justify-center">
          <p class="proffeo-ui-text-display text-center">
            {{ 'forgot-password-forgot-password' | translate }}
          </p>
        </div>
        <form
          [formRoot]="form"
          class="flex flex-col gap-4 pt-5"
        >
          <proffeo-ui-input
            [formField]="form.email"
            label="forgot-password-email-address"
            type="email"
            autocomplete="email"
          />

          <div class="flex flex-col items-center justify-center gap-2">
            @if (!showSuccessAlert().success) {
              <div class="flex w-full items-center justify-center pt-2">
                <proffeo-ui-button
                  (clicked)="onSubmitForm()"
                  [disabled]="form().invalid() || form().submitting()"
                  variant="accent"
                  text="forgot-password-send-reset-link"
                ></proffeo-ui-button>
              </div>
            }
            @if (showSuccessAlert().error) {
              <p class="text-sm font-light text-proffeo-danger">
                {{ 'forgot-password-sending-error' | translate }}
              </p>
            }

            @if (showSuccessAlert().success) {
              <p class="text-base text-proffeo-success">
                {{ 'forgot-password-password-reset-sent' | translate }}
              </p>
              <p class="text-base font-light">
                {{ 'forgot-password-you-will-receive-an-email-if-you-are-registered-on-our-system' | translate }}
              </p>
            }
          </div>

          <div class="flex w-full flex-col items-center justify-center">
            <p
              routerLink="/sign-in"
              class="cursor-pointer text-sm hover:opacity-75"
            >
              Go back to Login...
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
